import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { RootState } from "../index";
import { QuestionCategory } from "@/global/interfaces";

export interface AppState {
  questionCategories: QuestionCategory[];
}

export const state: AppState = {
  questionCategories: [],
};

const app: Module<AppState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};

export default app;
